import axios from 'axios';

export default class AjaxLoad {
  constructor(el) {
    this.el = el;

    if (!el.href) {
      return;
    }

    el.addEventListener('click', e => {
      let data = el.dataset;
      let target;
      const appendTo = data.appendTo;

      switch (true) {
      default:
        break;

      case !!e.target.target:
        target = e.target.target;
        break;

      case !!data.target:
        target = data.target;
        break;
      }

      const targetElem = document.querySelector(target);
      const appendToElem = document.querySelector(appendTo);

      axios({
        method: 'get',
        url: el.href,
        params: data,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(res => {
        if (res.data.isLast) {
          el.parentNode.removeChild(el);
        }

        if (res.data.data) {
          Object.keys(res.data.data).forEach(key => {
            el.dataset[key] = res.data.data[key];
          });
        }

        if (!res.data.content) {
          return;
        }

        if (targetElem) {
          targetElem.innerHTML = res.data.content;
          return;
        }

        if (appendToElem) {
          appendToElem.innerHTML = appendToElem.innerHTML + res.data.content;
        }
      }).catch(error => {
        throw `AjaxLoad.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
      });


      e.preventDefault();
    }, false);
  }
}
